export const notificationPlacement = 'topRight';

export const notificationDuration = 20;
